<p-dialog
  [visible]="showVideoPlayerDialog"
  (visibleChange)="onFlag('showVideoPlayerDialog', $event)"
  [blockScroll]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [showHeader]="true"
  [autoZIndex]="999"
  [style]="{ width: '800px', maxWidth: '100%' }"
  appendTo="body"
  styleClass="video-player-dialog">
  @if (showVideoPlayerDialog && videoReviewId) {
    <app-player-mux
      [muxVideoId]="videoReviewId"
      [showAutoplayOverlay]="false"
      [autoplay]="true"
      [muted]="true">
    </app-player-mux>
  }
</p-dialog>
